const getRndInteger = (min, max) => Math.floor(Math.random() * (max - min)) + min

const randomVariantGenerator = () => {
  const variants = [
    "light-primary",
    "light-success",
    "light-danger",
    "light-warning",
  ];

  return variants[getRndInteger(0, variants.length)];
}

const randomColorByIndex = (index) => {
  let colorIndex = index
  const variants = [
    "#7468F0",
    "#FF9F43",
    '#28C76F',
    "#00CFE8",
    "#EA5455",
  ];
  if (index > variants.length) {
    colorIndex -= variants.length
  }

  return variants[Math.min(colorIndex, variants.length)];
}

const randomBgColorByIndex = (index) => {
  let colorIndex = index
  const bg = [
    '#EEEDFD',
  '#FCEAEA',
  '#E5F8ED',
  '#E0F9FC',
  '#FCEAEA'
  ];

  if (index > bg.length) {
    colorIndex -= bg.length
  }

  return bg[Math.min(colorIndex, bg.length)];
}

const numberWithCommas = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}
const generateBgForBox = (colorInHex) => {
  const { r, g, b } = hexToRgb(colorInHex);
  return `rgba(${r},${g},${b},0.2)`;
}

export {
  randomVariantGenerator,
  numberWithCommas,
  generateBgForBox,
  randomColorByIndex,
  randomBgColorByIndex
}
